"use client";

import { useState, useEffect } from "react";

type Phase = "entering" | "holding" | "exiting" | "done";

type Props = {
  visible: boolean;
  label?: string;
  holdMs?: number;
  onComplete: () => void;
};

export const ValidationFlash = ({
  visible,
  label = "Parfait",
  holdMs = 900,
  onComplete,
}: Props) => {
  const [phase, setPhase] = useState<Phase>("done");

  useEffect(() => {
    if (visible) {
      setPhase("entering");
    }
  }, [visible]);

  useEffect(() => {
    if (phase === "entering") {
      const id = setTimeout(() => setPhase("holding"), 250);
      return () => clearTimeout(id);
    }
    if (phase === "holding") {
      const id = setTimeout(() => setPhase("exiting"), holdMs);
      return () => clearTimeout(id);
    }
    if (phase === "exiting") {
      const id = setTimeout(() => {
        setPhase("done");
        onComplete();
      }, 200);
      return () => clearTimeout(id);
    }
  }, [phase, holdMs, onComplete]);

  if (phase === "done") return null;

  const entering = phase === "entering";
  const exiting = phase === "exiting";

  return (
    <div
      className="flex items-center gap-3 rounded-xl px-5 py-3 transition-all"
      style={{
        backgroundColor: "rgba(34, 197, 94, 0.10)",
        border: "1px solid rgba(34, 197, 94, 0.25)",
        boxShadow: "0 0 20px rgba(34, 197, 94, 0.08)",
        opacity: exiting ? 0 : entering ? 0 : 1,
        transform: entering
          ? "translateY(-6px)"
          : "translateY(0)",
        transition: exiting
          ? "opacity 200ms ease-out"
          : "opacity 250ms cubic-bezier(0.16, 1, 0.3, 1), transform 250ms cubic-bezier(0.16, 1, 0.3, 1)",
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M3 8.5L6.5 12L13 4"
          stroke="var(--color-ok)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span
        className="text-[15px] font-bold"
        style={{ color: "var(--color-ok)" }}
      >
        {label}
      </span>
    </div>
  );
};
